import * as Sentry from '@sentry/vue'

/**
 * @param {unknown} error
 * @param {{ tags?: Record<string, string|number|boolean>, extra?: Record<string, unknown>, level?: Sentry.SeverityLevel }} context
 */
export function captureError(error, context = {}) {
  Sentry.withScope((scope) => {
    if (context.level) {
      scope.setLevel(context.level)
    }
    if (context.tags) {
      scope.setTags(context.tags)
    }
    if (context.extra) {
      scope.setExtras(context.extra)
    }

    Sentry.captureException(error)
  })
}
